import React from "react";

export default function HighlightComponent({ children }) {
  return <div className="highlight-container">{children}</div>;
}
